/**
 * ResultMessage.success("保存成功")
 * ResultMessage.error("保存失败", {duration: 3000})
 */

import React from "react";
import { Icon, Modal } from "antd";
import style from "./index.module.scss";

const DefaultDuration = 2000;
const DefaultWidth = 200;

declare type getContainerFunc = () => HTMLElement;

export interface ResultMessageProps {
    duration?: number;
    width?: number;
    getContainer?: string | HTMLElement | getContainerFunc | false | null;
    icon?: string;
    title?: string;
}

export class ResultMessage {
    static success(text: React.ReactNode, props?: ResultMessageProps) {
        const options = {
            duration: DefaultDuration,
            width: DefaultWidth,
            ...props
        };

        const modal = Modal.success({
            width: options.width,
            centered: true,
            maskClosable: true,
            content: (
                <div className={style.success}>
                    <Icon type="check-circle" theme="filled" />
                    <div>{text}</div>
                </div>
            ),
            getContainer: props?.getContainer,
            className: style.root
        });

        setTimeout(() => modal.destroy(), options.duration);
    }

    static error(text: React.ReactNode, props?: ResultMessageProps) {
        const options = {
            duration: DefaultDuration,
            width: DefaultWidth,
            ...props
        };

        const modal = Modal.success({
            width: options.width,
            centered: true,
            maskClosable: true,
            content: (
                <div className={style.error}>
                    <Icon
                        type={props?.icon ? props.icon : "close-circle"}
                        theme="filled"
                    />
                    <div className={style.title}>{props?.title}</div>
                    <div>{text}</div>
                </div>
            ),
            getContainer: props?.getContainer,
            className: style.root
        });

        setTimeout(() => modal.destroy(), options.duration);
    }
}
